/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingJpvDto } from './buildingJpvDto.model';
import { JpvParcelDto } from './jpvParcelDto.model';


export interface RightToBuildDto { 
    building?: BuildingJpvDto;
    datumPrijeti?: string;
    datumUkonceni?: string;
    endDate?: string;
    id?: number;
    katuzeKod?: number;
    katuzeNazev?: string;
    lv?: number;
    parcel?: JpvParcelDto;
    psId?: number;
    startDate?: string;
}

